import { useState } from 'react';
import { RefreshCw, X } from 'lucide-react';
import { Button } from '@/features/common/ui';
import { useInstallStore } from './install-store';

/**
 * "A new version of Fint is ready", when a build has installed behind the
 * page that is open.
 *
 * Offered, never forced. The person may be halfway through an invoice, and a
 * reload that discards it to deliver a version they did not ask for is the
 * wrong trade every time. The new worker has already taken over (it calls
 * skipWaiting), so the reload is the whole upgrade; closing the bar keeps
 * the old page running until the next page change, when StaleAppReload
 * reloads into the new one.
 *
 * Mounted above the router, so it appears on the login page too - a stale
 * login page is the one that cannot tell you why the API disagrees with it.
 */
export function UpdateBar() {
  const updateReady = useInstallStore((s) => s.updateReady);
  const [closed, setClosed] = useState(false);

  if (!updateReady || closed) return null;

  return (
    <div
      role="status"
      data-testid="update-bar"
      className="fixed inset-x-3 top-[calc(0.75rem+var(--safe-top))] z-50 flex items-center gap-3 rounded-lg border border-border bg-card p-3 text-sm text-card-foreground shadow-lg print:hidden sm:inset-x-auto sm:left-1/2 sm:max-w-md sm:-translate-x-1/2"
    >
      <RefreshCw className="size-4 shrink-0 text-primary" aria-hidden />
      <p className="min-w-0 flex-1">A new version of Fint is ready.</p>
      <Button size="sm" onClick={() => window.location.reload()}>
        Reload
      </Button>
      <button
        type="button"
        onClick={() => setClosed(true)}
        aria-label="Later"
        className="-m-1 shrink-0 rounded-md p-1 text-muted-foreground hover:bg-accent hover:text-foreground"
      >
        <X className="size-4" aria-hidden />
      </button>
    </div>
  );
}
